// extracted by mini-css-extract-plugin
export default {"returnPolicyOuterContainer":"ReturnPolicyLayout_returnPolicyOuterContainer__QzVZc","returnPolicyInnerContainer":"ReturnPolicyLayout_returnPolicyInnerContainer__X3I1p"};